<template>
  <div class="Emergency">
    <ScreenPanel :isExpand="isLeft">
      <ScreenBoxClick title="当年消防事件类型统计" menuCode="050501">
        <EventTypeStatistics/>
      </ScreenBoxClick>
      <ScreenBox title="当年应急事件趋势">
        <EventTrends/>
      </ScreenBox>
    </ScreenPanel>
    <ScreenPanel :isExpand="isRight" position="right">
      <ScreenBox title="当年应急事件概览">
        <EmergencyOverview/>
      </ScreenBox>
      <ScreenBox title="当年应急事件总数统计">
        <EventTotal/>
      </ScreenBox>
    </ScreenPanel>
  </div>
</template>

<script>
import ScreenPanel from "@ISS/situation/components/ScreenPanel";
import ScreenBox from "@ISS/situation/components/ScreenBox";
import ScreenBoxClick from "../components/ScreenBoxClick.vue";
import EventTypeStatistics from "@ISS/situation/components/EventTypeStatistics";
import EventTrends from "@ISS/situation/components/EventTrends";
import EmergencyOverview from "@ISS/situation/components/EmergencyOverview";
import EventTotal from "@ISS/situation/components/EventTotal";
export default {
  name: "Emergency",
  components: {EventTotal, EmergencyOverview, EventTrends, EventTypeStatistics, ScreenBox, ScreenBoxClick, ScreenPanel},
  data() {
    return {
      isLeft: false,
      isRight: false
    }
  },
  beforeDestroy() {
    this.$map.hideMap2D();
  },
  mounted() {
    this.isLeft = true;
    this.isRight = true;
    this.$map.showMap2D();
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.Emergency {

}
</style>
